import React, { useEffect, useRef } from 'react';
import { useReducedMotion } from 'framer-motion';
import { createNetworkScene } from '../utils/networkScene';
export function NetworkGraphic() {
  const ref = useRef<HTMLDivElement>(null);
  const reduce = useReducedMotion();
  useEffect(() => {
    if (!ref.current) return;
    return createNetworkScene(ref.current, {
      reducedMotion: Boolean(reduce)
    });
  }, [reduce]);
  return <div ref={ref} className="absolute inset-0" aria-hidden="true" data-id="element-228" data-mp="25bj18viqd8tg" />;
}